import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

class SentryManager {

    _isInitialized = false;
    _sentryAvailable = process.env.REACT_APP_ENABLE_SENTRY === "true";
    _DSN = process.env.REACT_APP_SENTRY_DSN;
    _environment = process.env.REACT_APP_SENTRY_ENV;


    initializeSentry() {
        if (!this._isInitialized && this._sentryAvailable) {
            Sentry.init({
                dsn: this._DSN,
                integrations: [new Integrations.BrowserTracing({
                    tracingOrigins: ["*"]
                })],
                tracesSampleRate: 1.0,
                environment: this._environment,
            });
            this._isInitialized = true;
            console.info('Sentry successfully connected')
        }
    }

    openUserSession(userData = {}) {
        if (this._isInitialized) {
            if (Boolean(Object.keys(userData).length)) {
                Sentry.setUser(userData);
                console.info(`opened Sentry user session - ${userData.id}`)
            } else {
                console.error(`User identification failed for 'Sentry'. Please ensure at least one identifying property is set (e.g., username, email, or user ID) to proceed.`)
            }
        }
    }

    clearUserSession() {
        if (this._isInitialized) {
            Sentry.setUser(null);
            console.info(`cleared Sentry user session`)

        }
    }

    captureException(error, extraInfo = {}) {
        if (this._isInitialized) {
            Sentry.captureException(error, {
                ...extraInfo,
            });
        } else {
            console.error('Sentry is not initialized.');
        }
    }
}

export default new SentryManager();



// WEBPACK FOOTER //
// ./src/monitoring/Sentry.js